import React from "react";
import PlantillasView from "./pages/PlantillasView";

export default function PlantillasFormacion() {
  return <PlantillasView />;
}
